
       function navigateFunction(url) {
           window.location.href=url;
       }

        document.addEventListener("DOMContentLoaded", function(event) {
        const options = document.querySelectorAll(".cat-filter select option");

          for (let i = 0; i < options.length; ++i) {
            const url = options[i].dataset.url;
            if(location.href.includes(url)) {
              document.querySelector('.cat-filter select').value = url;
            break;
          }
          }
          setCollectionMenu();
        });



        setCollectionMenu = () => {
          toggleMenu = () => {
            document.body.classList.toggle('collections-menu-open');
          }
          document.getElementById('openCollectionMenu') && document.getElementById('openCollectionMenu').addEventListener('click', toggleMenu);
          document.getElementById('closeCollectionMenu') && document.getElementById('closeCollectionMenu').addEventListener('click', toggleMenu);
        }


document.addEventListener('DOMContentLoaded', (event) =>  {

  adjustAnnouncementBar();
  setTimeout(() => {
      adjustAnnouncementBar();
  }, 1000);
  
});
addEventListener("resize", (event) => {
  adjustAnnouncementBar();
});

function adjustAnnouncementBar() {
  const announcementBarHeight = document.querySelector('#shopify-section-announcement-bar .announcement-bar').getBoundingClientRect().height;
      console.log(announcementBarHeight);

      document.querySelector('#shopify-section-header').style.paddingTop = announcementBarHeight + 'px';
}  